import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createVNode as _createVNode, isRef as _isRef, vModelCheckbox as _vModelCheckbox, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "inputGroup" }
const _hoisted_2 = { class: "groupTitle" }
const _hoisted_3 = { class: "groupInputs flex" }
const _hoisted_4 = { class: "inputRow" }
const _hoisted_5 = { class: "inputTitle" }
const _hoisted_6 = { class: "inputField flex-grow" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_8 = { class: "error-msg" }
const _hoisted_9 = { class: "inputRow" }
const _hoisted_10 = { class: "inputTitle" }
const _hoisted_11 = { class: "inputField flex-grow" }
const _hoisted_12 = { class: "inputGroup" }
const _hoisted_13 = { class: "groupTitle" }
const _hoisted_14 = { class: "groupInputs flex" }
const _hoisted_15 = { class: "inputRow" }
const _hoisted_16 = { class: "inputTitle" }
const _hoisted_17 = { class: "inputField flex-grow" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_19 = { class: "error-msg" }
const _hoisted_20 = { class: "inputRow" }
const _hoisted_21 = { class: "inputTitle" }
const _hoisted_22 = { class: "inputField flex-grow" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_24 = { class: "error-msg" }
const _hoisted_25 = { class: "groupInputs flex" }
const _hoisted_26 = { class: "inputRow" }
const _hoisted_27 = {
  key: 0,
  class: "inputField flex my-2"
}
const _hoisted_28 = ["disabled"]
const _hoisted_29 = { for: "unRegistrationCheck" }
const _hoisted_30 = {
  key: 0,
  class: "inputRow"
}
const _hoisted_31 = { class: "inputTitle" }
const _hoisted_32 = { class: "inputField flex-grow" }
const _hoisted_33 = { class: "error-msg" }
const _hoisted_34 = { class: "inputRow" }
const _hoisted_35 = { class: "inputTitle" }
const _hoisted_36 = { class: "inputField flex-grow" }
const _hoisted_37 = { class: "error-msg" }
const _hoisted_38 = { class: "inputGroup" }
const _hoisted_39 = { class: "groupTitle" }
const _hoisted_40 = { class: "groupInputs flex" }
const _hoisted_41 = { class: "inputRow" }
const _hoisted_42 = { class: "inputTitle" }
const _hoisted_43 = { class: "inputField flex-grow" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_45 = { class: "error-msg" }
const _hoisted_46 = { class: "inputRow" }
const _hoisted_47 = { class: "inputTitle" }
const _hoisted_48 = { class: "inputField flex-grow" }
const _hoisted_49 = { class: "groupInputs flex" }
const _hoisted_50 = { class: "inputRow" }
const _hoisted_51 = { class: "inputTitle" }
const _hoisted_52 = { class: "inputField flex-grow" }
const _hoisted_53 = { class: "inputRow" }
const _hoisted_54 = { class: "inputTitle" }
const _hoisted_55 = { class: "inputField flex-grow" }
const _hoisted_56 = { class: "groupInputs flex" }
const _hoisted_57 = { class: "inputRow" }
const _hoisted_58 = { class: "inputTitle" }
const _hoisted_59 = { class: "inputField flex-grow" }
const _hoisted_60 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_61 = { class: "error-msg" }
const _hoisted_62 = { class: "inputRow" }
const _hoisted_63 = { class: "inputTitle" }
const _hoisted_64 = { class: "inputField flex-grow" }
const _hoisted_65 = { class: "groupInputs flex" }
const _hoisted_66 = { class: "inputRow" }
const _hoisted_67 = { class: "inputTitle" }
const _hoisted_68 = { class: "inputField flex-grow" }
const _hoisted_69 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_70 = { class: "error-msg" }
const _hoisted_71 = { class: "inputRow" }
const _hoisted_72 = { class: "inputTitle" }
const _hoisted_73 = { class: "inputField flex-grow" }
const _hoisted_74 = { class: "error-msg" }
const _hoisted_75 = { class: "inputGroup" }
const _hoisted_76 = { class: "groupTitle" }
const _hoisted_77 = { class: "groupInputs flex" }
const _hoisted_78 = { class: "inputRow" }
const _hoisted_79 = { class: "inputField flex my-2" }
const _hoisted_80 = { class: "inputTitle ml-2" }
const _hoisted_81 = { for: "phoneNumberAltIsFallback" }
const _hoisted_82 = { class: "inputRow" }
const _hoisted_83 = { class: "inputField flex my-2" }
const _hoisted_84 = { class: "inputTitle ml-2" }
const _hoisted_85 = { for: "couplingEnabled" }
const _hoisted_86 = { class: "groupInputs flex" }
const _hoisted_87 = { class: "inputRow" }
const _hoisted_88 = { class: "inputTitle" }
const _hoisted_89 = { class: "inputField flex-grow" }
const _hoisted_90 = ["placeholder"]
const _hoisted_91 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_92 = { class: "error-msg" }
const _hoisted_93 = { class: "inputRow" }
const _hoisted_94 = { class: "inputTitle" }
const _hoisted_95 = { class: "inputField flex-grow" }
const _hoisted_96 = ["placeholder"]
const _hoisted_97 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_98 = { class: "error-msg" }
const _hoisted_99 = { class: "groupInputs flex" }
const _hoisted_100 = { class: "inputRow" }
const _hoisted_101 = { class: "inputTitle" }
const _hoisted_102 = { class: "inputField flex-grow" }
const _hoisted_103 = { class: "inputGroup" }
const _hoisted_104 = { class: "groupTitle" }
const _hoisted_105 = {
  key: 0,
  class: "groupInputs flex"
}
const _hoisted_106 = { class: "inputRow" }
const _hoisted_107 = { class: "inputField flex my-2" }
const _hoisted_108 = ["disabled"]
const _hoisted_109 = { class: "inputTitle ml-2" }
const _hoisted_110 = { for: "couplingEnabled" }
const _hoisted_111 = { class: "groupInputs flex" }
const _hoisted_112 = { class: "inputRow" }
const _hoisted_113 = { class: "inputTitle" }
const _hoisted_114 = { class: "inputField flex-grow" }
const _hoisted_115 = { class: "inputRow" }
const _hoisted_116 = { class: "inputTitle" }
const _hoisted_117 = { class: "inputField flex-grow" }
const _hoisted_118 = { class: "groupInputs flex" }
const _hoisted_119 = { class: "inputRow" }
const _hoisted_120 = { class: "inputTitle" }
const _hoisted_121 = { class: "inputField flex-grow" }
const _hoisted_122 = { class: "error-msg" }
const _hoisted_123 = { class: "inputRow" }
const _hoisted_124 = { class: "inputTitle" }
const _hoisted_125 = { class: "inputField flex-grow" }
const _hoisted_126 = { class: "groupInputs flex" }
const _hoisted_127 = {
  key: 0,
  class: "inputRow"
}
const _hoisted_128 = { class: "inputTitle" }
const _hoisted_129 = { class: "inputField flex-grow" }
const _hoisted_130 = { class: "inputRow" }
const _hoisted_131 = { class: "inputTitle" }
const _hoisted_132 = { class: "inputField flex-grow" }
const _hoisted_133 = { class: "block w-full mt-4" }
const _hoisted_134 = { class: "mb-4" }
const _hoisted_135 = { class: "tooltip infoIcon" }
const _hoisted_136 = /*#__PURE__*/_createElementVNode("span", { class: "icon-info" }, null, -1)
const _hoisted_137 = { class: "infoText tooltiptext shadow" }
const _hoisted_138 = { class: "grid grid-cols-2 gap-4 w-full" }
const _hoisted_139 = { class: "inputTitle" }
const _hoisted_140 = { class: "inputField flex-grow" }
const _hoisted_141 = { class: "error-msg" }
const _hoisted_142 = ["disabled"]

import Text from "@/components/inputs/Text";
    import { computed, onMounted, ref, toRef, watchEffect } from "vue";
    import Select from "@/components/inputs/Select";
    import ErrorHandler from "@/utilities/helpers/ErrorHandler";
    import { syncPostalCodeStringFromNumber } from "@/utilities/helpers/PostalCodeHelper";
    import { DisdiStateType, ErrorLocationType } from "@/utilities/enums/Enums";
    import Tags from "@/components/inputs/Tags";
    import { helpers, required, email, between, maxLength, minLength, numeric, requiredIf } from "@vuelidate/validators"
    import useVuelidate from "@vuelidate/core";
    import { useI18n } from "vue-i18n";
    import { useGlobalStore } from "@/stores/GlobalStore";
    import { Group1Service } from "@/utilities/services/entities/Group1Service";
    import { Group2Service } from "@/utilities/services/entities/Group2Service";
    import { SafetyInstructionService } from "@/utilities/services/entities/SafetyInstructionService";
    import { ControlCenterService } from "@/utilities/services/entities/ControlCenterService";
    import { MiscService } from "@/utilities/services/entities/MiscService";
    import TextOrSpinner from "@/components/TextOrSpinner";
    import { $t } from "@/utilities/i18n/config";
    import { ActivitySetService } from "@/utilities/services/entities/ActivitySetService";
    import { SettingService } from "@/utilities/services/entities/SettingService";
    import { phoneNumberPlaceholder } from "@/AppConfig";
    import { LocationInfo } from "@models/location/LocationInfo";

    
export default /*#__PURE__*/_defineComponent({
  __name: 'LocationInfoEditor',
  props: {
    data: null
  },
  setup(__props: any) {

const props = __props as { data: LocationInfo }

    const { t } = useI18n();
    const group1Service = new Group1Service();
    const group2Service = new Group2Service();
    const safetyInstructionService = new SafetyInstructionService();
    const controlCenterService = new ControlCenterService();
    const miscService = new MiscService();
    const activitySetService = new ActivitySetService();
    const settingService = new SettingService();

    

    const globalStore = useGlobalStore();
    const popupData = toRef(props, 'data');
    const callNumber = ref("");

    const regionList = ref(null);
    const levelList = ref(null);
    const controlCenterList = ref(null);
    const safetyInstructionList = ref(null);
    const pdfTemplateList = ref(null);
    const activitySetList = ref(null);
    const disdiIsOn = ref<boolean>(false);
    const disdiForAll = ref<boolean>(false);
    const loading = ref<boolean>(false);
    const minRadiusDiff = computed(() => globalStore.settings.automaticUnregisterMinDistance || 0);
    const automaticUnregisterSetting = computed(() => globalStore.settings.automaticUnregister?.toString());
    // "true" -> feature forced on, "false" -> feature forced off, "location" -> user can toggle
    const isAutomaticUnregisterFixed = computed(() => automaticUnregisterSetting.value === 'true' || automaticUnregisterSetting.value === 'false');
    const enabled = computed(() => {
        if (automaticUnregisterSetting.value === 'true') return true;
        if (automaticUnregisterSetting.value === 'false') return false;
        return popupData.value.hasUnRegistrationFeature;
    });
    const hasUnRegistrationFeatureProxy = computed({
        get() {
            if (automaticUnregisterSetting.value === 'true') return true;
            if (automaticUnregisterSetting.value === 'false') return false;
            return popupData.value.hasUnRegistrationFeature;
        },
        set(newValue: boolean) {
            if (isAutomaticUnregisterFixed.value) {
                return;
            }

            popupData.value.hasUnRegistrationFeature = newValue;

            if (newValue) {
                const regRadius = parseFloat(popupData.value.registrationRadius?.toString().replace(',', '.')) || 0;
                const minDiff = parseFloat(minRadiusDiff.value?.toString().replace(',', '.')) || 0;
                popupData.value.automaticUnRegisterRadius = regRadius + minDiff;
            } else {
                popupData.value.automaticUnRegisterRadius = undefined;
            }
        }
    });

    const automaticUnRegisterRadiusProxy = computed({
        get() {
            if (automaticUnregisterSetting.value === 'true') {
                const minDist = parseFloat(globalStore.settings.automaticUnregisterMinDistance?.toString().replace(',', '.')) || 0;
                const radius = parseFloat(globalStore.settings.automaticUnregisterRadius?.toString().replace(',', '.')) || 0;
                return minDist + radius;
            }
            return popupData.value.automaticUnRegisterRadius;
        },
        set(newValue) {
            popupData.value.automaticUnRegisterRadius = newValue;
        }
    });

    const getAtuto = async () => {

            const systemSettingsResp = await settingService.getSystemSettings();
            if (systemSettingsResp === null || systemSettingsResp === undefined || systemSettingsResp.statusCode !== 0) {
                ErrorHandler.handleError(systemSettingsResp, ErrorLocationType.table);
                return;
            }

            const flatGroupableList = [];
            for (const s of systemSettingsResp.settingInfo) {
                for (const c of s.children) {
                    c.groupName = s.name;
                    flatGroupableList.push(c)
                    if (c.groupName === "AutomatischeAbmeldung") {
                        if (c.refKey === "AutomatischeAbmeldungAktiv") {
                            globalStore.settings.automatischAbmeldung = c.value;
                        }
                    }
                }
            }

        }
    

   
    const autoAbmeldungEnabled = computed(() => {
        console.log("globalStore.settings.automatischAbmeldung: "+globalStore.settings.automatischAbmeldung)

       return globalStore.settings.automatischAbmeldung
    });


    // Computed Property für postalCodeString
    const postalCodeString = computed({
        get() {
            return popupData.value?.contactInfo?.postalCodeString ?? "";
        },
        set(newValue: string) {
            if (popupData.value?.contactInfo) {
                const normalizedValue = newValue.replace(
                    /[\u2010-\u2015\u2212]/g,
                    "-"
                );

                popupData.value.contactInfo.postalCodeString =
                    normalizedValue === "" ? null : normalizedValue;
            }
        }
    });

    const voiceTestCall = async () => {
        loading.value = true;

        const isValid = await testCallValidator.value.$validate();

        if (!isValid) {
            loading.value = false;

            const targetElement = document.querySelector(".error");
            targetElement.scrollIntoView({ behavior: "smooth", block: 'center' });

            return;
        }

        // check if there is a name pronunciation
        let nameToRead = "";
        if (popupData.value.namePronunciation === "") {
            nameToRead = popupData.value.name;
        } else {
            nameToRead = popupData.value.namePronunciation;
        }

        // sadly can't get generalResponse here so it is fire and forget
        await miscService.postVoiceTestCall(nameToRead, callNumber.value);

        loading.value = false;
    };

    const setActivitySetId = (id) => {
        popupData.value.activitySetId = id;
    }

    const setPdfTemplate = (id) => {
        popupData.value.pdfTemplate = id;
    }

    const selectionChanged = (selectedList) => {
        popupData.value.safetyInstructions = selectedList;
    }

    watchEffect(() => {
        if (popupData.value.controlCenterId !== undefined && popupData.value.controlCenterId !== null && controlCenterList.value !== null)
            popupData.value.controlCenterName = controlCenterList.value.find(cc => cc.id === popupData.value.controlCenterId)?.name;

        return popupData.value.controlCenterId
    });

    watchEffect(() => {
        if (popupData.value.group1Id !== null && regionList.value !== null)
            popupData.value.group1Name = regionList.value.find(g1 => g1.id === popupData.value.group1Id)?.name;

        return popupData.value.group1Id
    });

    watchEffect(() => {
        if (popupData.value.group2Id !== null && levelList.value !== null)
            popupData.value.group2Name = levelList.value.find(g2 => g2.id === popupData.value.group2Id)?.name;

        return popupData.value.group2Id
    });

    onMounted(async () => {
        disdiIsOn.value = globalStore.settings.disdiSettings?.disdi !== DisdiStateType.NoDISDI;
        disdiForAll.value = globalStore.settings.disdiSettings?.disdi === DisdiStateType.AllLocations;

        // initialize postalCodeString from the existing postalCode when not already set
        syncPostalCodeStringFromNumber(popupData.value?.contactInfo);

        const regionResp = await group1Service.getRegions();
        if (regionResp === null || regionResp === undefined || regionResp.statusCode !== 0) {
            ErrorHandler.handleError(regionResp, ErrorLocationType.popup);
            return;
        }
        regionList.value = regionResp.regionInfo;

        const levelResp = await group2Service.getLevels();
        if (levelResp === null || levelResp === undefined || levelResp.statusCode !== 0) {
            ErrorHandler.handleError(levelResp, ErrorLocationType.popup);
            return;
        }
        levelList.value = levelResp.levelInfo;

        const controlCenterResp = await controlCenterService.getControlCenters()
        if (controlCenterResp === null || controlCenterResp === undefined || controlCenterResp.statusCode !== 0) {
            ErrorHandler.handleError(controlCenterResp, ErrorLocationType.popup);
            return;
        }
        controlCenterList.value = controlCenterResp.controlCenterInfo;

        const safetyInstructionResp = await safetyInstructionService.getSafetyInstructions();
        if (safetyInstructionResp === null || safetyInstructionResp === undefined || safetyInstructionResp.statusCode !== 0) {
            ErrorHandler.handleError(safetyInstructionResp, ErrorLocationType.popup);
            return;
        }
        safetyInstructionList.value = safetyInstructionResp.safetyInstructionInfo;

        const templateResp = await miscService.getPdfTemplates();
        if (templateResp === null || templateResp === undefined || templateResp.statusCode !== 0) {
            ErrorHandler.handleError(templateResp, ErrorLocationType.popup);
            return;
        }
        pdfTemplateList.value = templateResp.selectablePDFTemplate;

        // convert si list on popupData
        const convertedArray = [];
        for (const item of popupData.value.safetyInstructions) {
            const fullInstruction = safetyInstructionList.value.find(si => si.id === item);

            const convertedItem = {
                id: item,
                name: fullInstruction.name
            };
            convertedArray.push(convertedItem);

            safetyInstructionList.value = safetyInstructionList.value.filter(si => si.id !== item);
        }
        popupData.value.safetyInstructions = convertedArray;

        const activitySetResp = await activitySetService.getActivitySets();
        if (activitySetResp === null || activitySetResp === undefined || activitySetResp.statusCode !== 0) {
            ErrorHandler.handleError(activitySetResp, ErrorLocationType.popup);
            return;
        }
        activitySetList.value = activitySetResp.activitySetInfo.map(as => {
            as.id = as.activitySetId;
            return as;
        });
        getAtuto();
    });

    // Validation
    const phoneNumbersValidator = helpers.regex(/^\+[0-9]+$/);
    const floatValidator = helpers.regex(/^\d*[.,]?\d+?$/);
    const postalCodeValidator = helpers.regex(
        /^(?:\d{4}|\d{5}|\d{2}-\d{3}|\d{3}\s?\d{2}|\d{4}\s?[A-Z]{2}|[A-Z]\d[A-Z]\s?\d[A-Z]\d|\d{4}-\d{3}|\d{5}-\d{4})$/i
    );
    const rules = computed(() => {
        const rules = {
            registrationRadius: {
                floatValidator: helpers.withMessage(
                    t('validators.float'),
                    floatValidator
                ),
            },
            hasUnRegistrationFeature: {},


            automaticUnRegisterRadius: {
                required: helpers.withMessage(t('validators.required'), requiredIf(() => enabled.value)),
                numeric: helpers.withMessage(t('validators.numeric'), enabled.value ? numeric : () => true),
                minValue: helpers.withMessage(
                    t('validators.minValue', { amount: 0 }),
                    enabled.value ? helpers.withParams({ type: 'minValue' }, (v: any) => Number(v) > 0) : () => true
                ),
                minDiff: helpers.withMessage(
                    t('error.status.5019'),
                    (value: any) => {
                        if (!enabled.value) return true;
                        const regRadius = parseFloat(popupData.value.registrationRadius?.toString().replace(',','.')) || 0;
                        const autoRadius = parseFloat(value?.toString().replace(',','.')) || 0;
                        const minDiff = parseFloat(minRadiusDiff.value?.toString().replace(',','.')) || 0;
                        // Avoid floating point issues with small epsilon if needed, but simple comparison should suffice for this logic
                        return autoRadius >= (regRadius + minDiff);
                    }
                )
            },
            secondaryId: {
                required: helpers.withMessage(t('validators.required'), required),
                numeric: helpers.withMessage(t('validators.numeric'), numeric),
                maxLength: helpers.withMessage(t('validators.maxLength', { amount: 5 }), maxLength(5)),
                minLength: helpers.withMessage(t('validators.minLength', { amount: 5 }), minLength(5))
            },
            name: { required: helpers.withMessage(t('validators.required'), required) },
            email: {
                required: helpers.withMessage(t('validators.required'), required),
                email: helpers.withMessage(t('validators.email'), email)
            },
            controlCenterId: { required: helpers.withMessage(t('validators.required'), required) },
            longitude: {
                between: helpers.withMessage(t('validators.longitude'), between(-180, 180)),
            },
            latitude: {
                between: helpers.withMessage(t('validators.latitude'), between(-90, 90)),
            },
            contactInfo: {
                phoneNumber: {
                    phoneNumbersValidator: helpers.withMessage(
                        t('validators.phoneNumber'),
                        phoneNumbersValidator
                    ),
                },
                phoneNumberAlt1: {
                    phoneNumbersValidator: helpers.withMessage(
                        t('validators.phoneNumber'),
                        phoneNumbersValidator
                    ),
                },
                phoneNumberAlt2: {
                    phoneNumbersValidator: helpers.withMessage(
                        t('validators.phoneNumber'),
                        phoneNumbersValidator
                    ),
                },
                postalCodeString: {
                    postalCodeValidator: helpers.withMessage(
                        t('validators.postalCode'),
                        postalCodeValidator
                    )
                }
            },
        }
        return rules
    })
    const v$ = useVuelidate(rules, popupData)




    const readerRules = computed(() => {
        return {
            numberToCall: {
                phoneNumbersValidator: helpers.withMessage(
                    $t('validators.phoneNumber'),
                    phoneNumbersValidator
                ),
                required: helpers.withMessage(
                    $t('validators.required'),
                    required
                )
            },
        }
    })

    const callData = computed(() => {
        return { numberToCall: callNumber.value }
    })

    const hideCallValidatorErrors = () => {
        testCallValidator.$reset();
    }
    const testCallValidator = useVuelidate(readerRules, callData)
    onMounted(() => {
        globalStore.modal.validator = v$;
    })


return (_ctx: any,_cache: any) => {
  const _directive_permission = _resolveDirective("permission")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, _toDisplayString(_unref($t)('popups.locationInfo.section1')), 1),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, _toDisplayString(_unref($t)('popups.locationInfo.secondaryId')) + " * ", 1),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", {
              class: _normalizeClass({ error: _unref(v$).secondaryId.$errors.length })
            }, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(popupData).secondaryId) = $event)),
                class: "w-full"
              }, null, 512), [
                [_vModelText, _unref(popupData).secondaryId]
              ]),
              _hoisted_7,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(v$).secondaryId.$errors, (error) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "input-errors",
                  key: error.$uid
                }, [
                  _createElementVNode("div", _hoisted_8, _toDisplayString(error.$message), 1)
                ]))
              }), 128))
            ], 2)
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, _toDisplayString(_unref($t)('popups.locationInfo.syncId')), 1),
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_unref(Text), {
              modelValue: _unref(popupData).syncId,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(popupData).syncId) = $event))
            }, null, 8, ["modelValue"])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("div", _hoisted_13, _toDisplayString(_unref($t)('popups.locationInfo.AnAbmeldung')), 1),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, _toDisplayString(_unref($t)('popups.locationInfo.latitude')), 1),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", {
              class: _normalizeClass({ error: _unref(v$).latitude.$errors.length })
            }, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(popupData).latitude) = $event)),
                class: "w-full"
              }, null, 512), [
                [_vModelText, _unref(popupData).latitude]
              ]),
              _hoisted_18,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(v$).latitude.$errors, (error) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "input-errors",
                  key: error.$uid
                }, [
                  _createElementVNode("div", _hoisted_19, _toDisplayString(error.$message), 1)
                ]))
              }), 128))
            ], 2)
          ])
        ]),
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("div", _hoisted_21, _toDisplayString(_unref($t)('popups.locationInfo.longitude')), 1),
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("div", {
              class: _normalizeClass({ error: _unref(v$).longitude.$errors.length })
            }, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(popupData).longitude) = $event)),
                class: "w-full"
              }, null, 512), [
                [_vModelText, _unref(popupData).longitude]
              ]),
              _hoisted_23,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(v$).longitude.$errors, (error) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "input-errors",
                  key: error.$uid
                }, [
                  _createElementVNode("div", _hoisted_24, _toDisplayString(error.$message), 1)
                ]))
              }), 128))
            ], 2)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_25, [
        _createElementVNode("div", _hoisted_26, [
          (_unref(autoAbmeldungEnabled))
            ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                _withDirectives(_createElementVNode("input", {
                  id: "unRegistrationCheck",
                  type: "checkbox",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_isRef(hasUnRegistrationFeatureProxy) ? (hasUnRegistrationFeatureProxy).value = $event : null)),
                  disabled: _unref(isAutomaticUnregisterFixed)
                }, null, 8, _hoisted_28), [
                  [_vModelCheckbox, _unref(hasUnRegistrationFeatureProxy)]
                ]),
                _createElementVNode("label", _hoisted_29, _toDisplayString(_unref($t)('popups.locationInfo.unRegistrationCheck')), 1)
              ]))
            : _createCommentVNode("", true)
        ]),
        (_unref(autoAbmeldungEnabled))
          ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
              _createElementVNode("div", _hoisted_31, _toDisplayString(_unref($t)('popups.locationInfo.unRegistrationRadius')), 1),
              _createElementVNode("div", _hoisted_32, [
                _createElementVNode("div", {
                  class: _normalizeClass({ error: _unref(v$).automaticUnRegisterRadius.$errors.length })
                }, [
                  _createVNode(_unref(Text), {
                    disabled: !_unref(enabled),
                    modelValue: _unref(automaticUnRegisterRadiusProxy),
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_isRef(automaticUnRegisterRadiusProxy) ? (automaticUnRegisterRadiusProxy).value = $event : null))
                  }, null, 8, ["disabled", "modelValue"]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(v$).automaticUnRegisterRadius.$errors, (error) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "input-errors",
                      key: error.$uid
                    }, [
                      _createElementVNode("div", _hoisted_33, _toDisplayString(error.$message), 1)
                    ]))
                  }), 128))
                ], 2)
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_34, [
          _createElementVNode("div", _hoisted_35, _toDisplayString(_unref($t)('popups.locationInfo.registrationRadius')), 1),
          _createElementVNode("div", _hoisted_36, [
            _createElementVNode("div", {
              class: _normalizeClass({ error: _unref(v$).registrationRadius.$errors.length })
            }, [
              _createVNode(_unref(Text), {
                modelValue: _unref(popupData).registrationRadius,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(popupData).registrationRadius) = $event))
              }, null, 8, ["modelValue"]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(v$).registrationRadius.$errors, (error) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "input-errors",
                  key: error.$uid
                }, [
                  _createElementVNode("div", _hoisted_37, _toDisplayString(error.$message), 1)
                ]))
              }), 128))
            ], 2)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_38, [
      _createElementVNode("div", _hoisted_39, _toDisplayString(_unref($t)('popups.locationInfo.section2')), 1),
      _createElementVNode("div", _hoisted_40, [
        _createElementVNode("div", _hoisted_41, [
          _createElementVNode("div", _hoisted_42, _toDisplayString(_unref($t)('popups.locationInfo.name')) + " * ", 1),
          _createElementVNode("div", _hoisted_43, [
            _createElementVNode("div", {
              class: _normalizeClass({ error: _unref(v$).name.$errors.length })
            }, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(popupData).name) = $event)),
                ref: "name",
                class: "w-full"
              }, null, 512), [
                [_vModelText, _unref(popupData).name]
              ]),
              _hoisted_44,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(v$).name.$errors, (error) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "input-errors",
                  key: error.$uid
                }, [
                  _createElementVNode("div", _hoisted_45, _toDisplayString(error.$message), 1)
                ]))
              }), 128))
            ], 2)
          ])
        ]),
        _createElementVNode("div", _hoisted_46, [
          _createElementVNode("div", _hoisted_47, _toDisplayString(_unref($t)('popups.locationInfo.namePronunciation')), 1),
          _createElementVNode("div", _hoisted_48, [
            _createVNode(_unref(Text), {
              modelValue: _unref(popupData).namePronunciation,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(popupData).namePronunciation) = $event))
            }, null, 8, ["modelValue"])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_49, [
        _createElementVNode("div", _hoisted_50, [
          _createElementVNode("div", _hoisted_51, _toDisplayString(_unref($t)('popups.locationInfo.street')), 1),
          _createElementVNode("div", _hoisted_52, [
            _createVNode(_unref(Text), {
              modelValue: _unref(popupData).contactInfo.street,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(popupData).contactInfo.street) = $event))
            }, null, 8, ["modelValue"])
          ])
        ]),
        _createElementVNode("div", _hoisted_53, [
          _createElementVNode("div", _hoisted_54, _toDisplayString(_unref($t)('popups.locationInfo.streetNumber')), 1),
          _createElementVNode("div", _hoisted_55, [
            _createVNode(_unref(Text), {
              modelValue: _unref(popupData).contactInfo.streetNumber,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_unref(popupData).contactInfo.streetNumber) = $event))
            }, null, 8, ["modelValue"])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_56, [
        _createElementVNode("div", _hoisted_57, [
          _createElementVNode("div", _hoisted_58, _toDisplayString(_unref($t)('popups.locationInfo.postalCode')), 1),
          _createElementVNode("div", _hoisted_59, [
            _createElementVNode("div", {
              class: _normalizeClass({ error: _unref(v$).contactInfo.postalCodeString.$errors.length })
            }, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_isRef(postalCodeString) ? (postalCodeString).value = $event : null)),
                class: "w-full"
              }, null, 512), [
                [_vModelText, _unref(postalCodeString)]
              ]),
              _hoisted_60,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(v$).contactInfo.postalCodeString.$errors, (error) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "input-errors",
                  key: error.$uid
                }, [
                  _createElementVNode("div", _hoisted_61, _toDisplayString(error.$message), 1)
                ]))
              }), 128))
            ], 2)
          ])
        ]),
        _createElementVNode("div", _hoisted_62, [
          _createElementVNode("div", _hoisted_63, _toDisplayString(_unref($t)('popups.locationInfo.city')), 1),
          _createElementVNode("div", _hoisted_64, [
            _createVNode(_unref(Text), {
              modelValue: _unref(popupData).contactInfo.city,
              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_unref(popupData).contactInfo.city) = $event))
            }, null, 8, ["modelValue"])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_65, [
        _createElementVNode("div", _hoisted_66, [
          _createElementVNode("div", _hoisted_67, _toDisplayString(_unref($t)('popups.locationInfo.email')) + " * ", 1),
          _createElementVNode("div", _hoisted_68, [
            _createElementVNode("div", {
              class: _normalizeClass({ error: _unref(v$).email.$errors.length })
            }, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_unref(popupData).email) = $event)),
                class: "w-full"
              }, null, 512), [
                [_vModelText, _unref(popupData).email]
              ]),
              _hoisted_69,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(v$).email.$errors, (error) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "input-errors",
                  key: error.$uid
                }, [
                  _createElementVNode("div", _hoisted_70, _toDisplayString(error.$message), 1)
                ]))
              }), 128))
            ], 2)
          ])
        ]),
        _createElementVNode("div", _hoisted_71, [
          _createElementVNode("div", _hoisted_72, _toDisplayString(_unref($t)('popups.locationInfo.phoneNumber')), 1),
          _createElementVNode("div", _hoisted_73, [
            _createElementVNode("div", {
              class: _normalizeClass({ error: _unref(v$).contactInfo.phoneNumber.$errors.length })
            }, [
              _createVNode(_unref(Text), {
                modelValue: _unref(popupData).contactInfo.phoneNumber,
                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_unref(popupData).contactInfo.phoneNumber) = $event)),
                placeholder: _unref(phoneNumberPlaceholder)
              }, null, 8, ["modelValue", "placeholder"]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(v$).contactInfo.phoneNumber.$errors, (error) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "input-errors",
                  key: error.$uid
                }, [
                  _createElementVNode("div", _hoisted_74, _toDisplayString(error.$message), 1)
                ]))
              }), 128))
            ], 2)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_75, [
      _createElementVNode("div", _hoisted_76, _toDisplayString(_unref($t)('popups.locationInfo.section3')), 1),
      _createElementVNode("div", _hoisted_77, [
        _createElementVNode("div", _hoisted_78, [
          _createElementVNode("div", _hoisted_79, [
            _withDirectives(_createElementVNode("input", {
              type: "checkbox",
              "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_unref(popupData).phoneNumberAltIsFallback) = $event)),
              name: "phoneNumberAltIsFallback"
            }, null, 512), [
              [_vModelCheckbox, _unref(popupData).phoneNumberAltIsFallback]
            ]),
            _createElementVNode("div", _hoisted_80, [
              _createElementVNode("label", _hoisted_81, _toDisplayString(_unref($t)('popups.locationInfo.phoneNumberAltIsFallback')), 1)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_82, [
          _createElementVNode("div", _hoisted_83, [
            _withDirectives(_createElementVNode("input", {
              type: "checkbox",
              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_unref(popupData).couplingEnabled) = $event)),
              name: "couplingEnabled"
            }, null, 512), [
              [_vModelCheckbox, _unref(popupData).couplingEnabled]
            ]),
            _createElementVNode("div", _hoisted_84, [
              _createElementVNode("label", _hoisted_85, _toDisplayString(_unref($t)('popups.locationInfo.couplingEnabled')), 1)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_86, [
        _createElementVNode("div", _hoisted_87, [
          _createElementVNode("div", _hoisted_88, _toDisplayString(_unref($t)('popups.locationInfo.phoneNumberAlt1')), 1),
          _createElementVNode("div", _hoisted_89, [
            _createElementVNode("div", {
              class: _normalizeClass({ error: _unref(v$).contactInfo.phoneNumberAlt1.$errors.length })
            }, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_unref(popupData).phoneNumberAlt1) = $event)),
                class: "w-full",
                placeholder: _unref(phoneNumberPlaceholder)
              }, null, 8, _hoisted_90), [
                [_vModelText, _unref(popupData).phoneNumberAlt1]
              ]),
              _hoisted_91,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(v$).contactInfo.phoneNumberAlt1.$errors, (error) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "input-errors",
                  key: error.$uid
                }, [
                  _createElementVNode("div", _hoisted_92, _toDisplayString(error.$message), 1)
                ]))
              }), 128))
            ], 2)
          ])
        ]),
        _createElementVNode("div", _hoisted_93, [
          _createElementVNode("div", _hoisted_94, _toDisplayString(_unref($t)('popups.locationInfo.phoneNumberAlt2')), 1),
          _createElementVNode("div", _hoisted_95, [
            _createElementVNode("div", {
              class: _normalizeClass({ error: _unref(v$).contactInfo.phoneNumberAlt2.$errors.length })
            }, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_unref(popupData).phoneNumberAlt2) = $event)),
                class: "w-full",
                placeholder: _unref(phoneNumberPlaceholder)
              }, null, 8, _hoisted_96), [
                [_vModelText, _unref(popupData).phoneNumberAlt2]
              ]),
              _hoisted_97,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(v$).contactInfo.phoneNumberAlt2.$errors, (error) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "input-errors",
                  key: error.$uid
                }, [
                  _createElementVNode("div", _hoisted_98, _toDisplayString(error.$message), 1)
                ]))
              }), 128))
            ], 2)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_99, [
        _createElementVNode("div", _hoisted_100, [
          _createElementVNode("div", _hoisted_101, _toDisplayString(_unref($t)('popups.locationInfo.customAdditionalInformation')), 1),
          _createElementVNode("div", _hoisted_102, [
            _createVNode(_unref(Text), {
              modelValue: _unref(popupData).customAdditionalInformation,
              "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_unref(popupData).customAdditionalInformation) = $event))
            }, null, 8, ["modelValue"])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_103, [
      _createElementVNode("div", _hoisted_104, _toDisplayString(_unref($t)('popups.locationInfo.section4')), 1),
      (disdiIsOn.value)
        ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_105, [
            _createElementVNode("div", _hoisted_106, [
              _createElementVNode("div", _hoisted_107, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_unref(popupData).hasDisdi) = $event)),
                  disabled: disdiForAll.value,
                  name: "hasDisdi"
                }, null, 8, _hoisted_108), [
                  [_vModelCheckbox, _unref(popupData).hasDisdi]
                ]),
                _createElementVNode("div", _hoisted_109, [
                  _createElementVNode("label", _hoisted_110, _toDisplayString(_unref($t)('popups.locationInfo.hasDisdi')), 1)
                ])
              ])
            ])
          ])), [
            [_directive_permission, 'Disdi.LocationPropertyEdit']
          ])
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_111, [
        _createElementVNode("div", _hoisted_112, [
          _createElementVNode("div", _hoisted_113, _toDisplayString(_unref($t)('popups.locationInfo.group1AndName')), 1),
          _createElementVNode("div", _hoisted_114, [
            _createVNode(_unref(Select), {
              selected: _unref(popupData).group1Id,
              options: regionList.value,
              mode: "single",
              onSelectChanged: _cache[21] || (_cache[21] = (value)=>{_unref(popupData).group1Id = value})
            }, null, 8, ["selected", "options"])
          ])
        ]),
        _createElementVNode("div", _hoisted_115, [
          _createElementVNode("div", _hoisted_116, _toDisplayString(_unref($t)('popups.locationInfo.group2IdAndName')), 1),
          _createElementVNode("div", _hoisted_117, [
            _createVNode(_unref(Select), {
              selected: _unref(popupData).group2Id,
              options: levelList.value,
              mode: "single",
              onSelectChanged: _cache[22] || (_cache[22] = (value)=>{_unref(popupData).group2Id = value})
            }, null, 8, ["selected", "options"])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_118, [
        _createElementVNode("div", _hoisted_119, [
          _createElementVNode("div", _hoisted_120, _toDisplayString(_unref($t)('popups.locationInfo.controlCenterIdAndName')) + " * ", 1),
          _createElementVNode("div", _hoisted_121, [
            _createElementVNode("div", {
              class: _normalizeClass({ error: _unref(v$).controlCenterId.$errors.length })
            }, [
              _createVNode(_unref(Select), {
                selected: _unref(popupData).controlCenterId,
                options: controlCenterList.value,
                mode: "single",
                onSelectChanged: _cache[23] || (_cache[23] = (value)=>{_unref(popupData).controlCenterId = value})
              }, null, 8, ["selected", "options"]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(v$).controlCenterId.$errors, (error) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "input-errors",
                  key: error.$uid
                }, [
                  _createElementVNode("div", _hoisted_122, _toDisplayString(error.$message), 1)
                ]))
              }), 128))
            ], 2)
          ])
        ]),
        _createElementVNode("div", _hoisted_123, [
          _createElementVNode("div", _hoisted_124, _toDisplayString(_unref($t)('popups.locationInfo.safetyInstructions')), 1),
          _createElementVNode("div", _hoisted_125, [
            _createVNode(_unref(Tags), {
              options: safetyInstructionList.value,
              selected: _unref(popupData).safetyInstructions,
              onSelectChanged: selectionChanged
            }, null, 8, ["options", "selected"])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_126, [
        (_unref(globalStore).settings.activitySettings.activitesEnabled)
          ? (_openBlock(), _createElementBlock("div", _hoisted_127, [
              _createElementVNode("div", _hoisted_128, _toDisplayString(_unref($t)('popups.locationInfo.activitySet')), 1),
              _createElementVNode("div", _hoisted_129, [
                _createVNode(_unref(Select), {
                  selected: _unref(popupData).activitySetId,
                  options: activitySetList.value,
                  mode: "single",
                  onSelectChanged: setActivitySetId
                }, null, 8, ["selected", "options"])
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_130, [
          _createElementVNode("div", _hoisted_131, _toDisplayString(_unref($t)('popups.locationInfo.pdfTemplate')), 1),
          _createElementVNode("div", _hoisted_132, [
            _createVNode(_unref(Select), {
              selected: _unref(popupData).pdfTemplate,
              options: pdfTemplateList.value,
              mode: "single",
              onSelectChanged: setPdfTemplate
            }, null, 8, ["selected", "options"])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_133, [
        _createElementVNode("h3", _hoisted_134, [
          _createTextVNode(_toDisplayString(_unref($t)('popups.locationInfo.readerTitle')) + " ", 1),
          _createElementVNode("span", _hoisted_135, [
            _hoisted_136,
            _createElementVNode("span", _hoisted_137, _toDisplayString(_unref($t)('popups.locationInfo.readerTooltip')), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_138, [
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_139, _toDisplayString(_unref($t)('popups.locationInfo.readerPhonenumber')), 1),
            _createElementVNode("div", _hoisted_140, [
              _createElementVNode("div", {
                class: _normalizeClass({ error: _unref(testCallValidator).numberToCall.$errors.length })
              }, [
                _createVNode(_unref(Text), {
                  modelValue: callNumber.value,
                  "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((callNumber).value = $event)),
                  onFocusout: hideCallValidatorErrors,
                  placeholder: _unref(phoneNumberPlaceholder)
                }, null, 8, ["modelValue", "placeholder"]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(testCallValidator).numberToCall.$errors, (error) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "input-errors",
                    key: error.$uid
                  }, [
                    _createElementVNode("div", _hoisted_141, _toDisplayString(error.$message), 1)
                  ]))
                }), 128))
              ], 2),
              _createElementVNode("button", {
                class: "primary mt-2",
                onClick: voiceTestCall,
                disabled: loading.value
              }, [
                _createVNode(_unref(TextOrSpinner), {
                  text: _unref($t)('popups.reader.button'),
                  spin: loading.value
                }, null, 8, ["text", "spin"])
              ], 8, _hoisted_142)
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})